import { reverse, routing } from '@utils/routing';
export const getProductHref = (slug) => {
    const url = new URL(reverse(routing.productCatalog.product, { slug }), window.location.origin);
    url.searchParams.set('source', 'dashboard-reco');
    return url.toString();
};
